import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import {AuthService, } from "./auth";
import {filter, map, shareReplay} from "rxjs/operators";
import { EventBusService } from '../services/event-bus.service';
import {EventName, EventData} from "@signature-it/ngx-generic/classes";
@Injectable({
    providedIn: 'root'
})

export class CngPermissionsService {
    protected screenFieldPermissions$ = {}
    protected getScreenPermissionsUrl = `${this.config.appURL}/admin/cng/permissions`;
    protected getScreenFieldPermissionsUrl = `${this.config.appURL}/public/screen/authorized-questions`;
    screenPermissions: {} = {};
    screenFieldPermissions: {} = {};
    eventBusService: EventBusService = inject(EventBusService);
    constructor(
        protected http: HttpClient,
        protected config: RestUrlsConfig,
        protected authService: AuthService,
    ) {}


    getScreenPermissions(cngId) {
        if(!this.screenPermissions[cngId]) {
            this.screenPermissions[cngId] = this.http.post(this.getScreenPermissionsUrl, JSON.stringify({cngId})).pipe(
                shareReplay(1)
            );
        }
        return this.screenPermissions[cngId];
    }

    hasPermission(cngId, permission): Observable<boolean>  {
        return new Observable(observer => {
            this.getScreenPermissions(cngId).subscribe(permissions =>
            {
                if(!Object.keys(permissions).length) {
                    observer.next(true);
                    observer.complete();
                } else {
                    this.authService.usersData$.pipe(filter(user=> !!user)).subscribe(userData => {
                        if( Object.keys(userData['acm_groups'])?.some((g:any) => permissions[permission]?.indexOf(g) > -1)) {
                            observer.next(true);
                        } else {
                            observer.next(false);
                        }
                        observer.complete();
                    })
                }


            })

    })
    }

    getScreenFieldPermissions(cngProductId,cngId): Observable<{ question_id: string; disable: string }[]> {
        if(!this.screenFieldPermissions[cngProductId]) {
            this.screenFieldPermissions[cngProductId] = this.http.get(`${this.getScreenFieldPermissionsUrl}/${cngProductId}/${cngId}`).pipe(
                shareReplay(1)
            );
        }
        return this.screenFieldPermissions[cngProductId];
    }

    hasFieldPermissions(cngProductId, questionId, cngId) {
        if(!this.screenFieldPermissions$[cngProductId]) {
            this.screenFieldPermissions$[cngProductId] = {};
        }
        if(!this.screenFieldPermissions$[cngProductId][questionId]) {
            this.screenFieldPermissions$[cngProductId][questionId] = this.getScreenFieldPermissions(cngProductId,cngId).pipe(
                map(fieldsPermission => {
                    if(!Object.keys(fieldsPermission).length) {
                        return { read: true, update: true };
                    }
                    const read = fieldsPermission.some(q => q.question_id == questionId);
                    const update = fieldsPermission.some(q => q.question_id == questionId && q.disable == "0");
                    return { read, update };
                })
            );
        }
        return this.screenFieldPermissions$[cngProductId][questionId];
    }

    refreshScreenPermission(cngProductId) {
        this.screenFieldPermissions[cngProductId] = null;
        this.screenFieldPermissions$[cngProductId] = null;
        this.eventBusService.emit(new EventData(`${EventName.REFRESH_CNG_PERMISSIONS_FIELDS}`, true));
    }
}
